import APU from "../../assets/images/apu.webp";
import Curtin from "../../assets/images/curtin-malaysia.webp";
import Help from "../../assets/images/help.webp";
import HeriotWatt from "../../assets/images/heriot-watt-university-malaysia.webp";
import IGlobal from "../../assets/images/iglobal.webp";
import Manipal from "../../assets/images/manipal-university-college.webp";
import MIA from "../../assets/images/mia.webp";
import QIU from "../../assets/images/qiu.webp";
import Raffles from "../../assets/images/raffles-university.webp";
import Segi from "../../assets/images/segi.webp";
import Southampton from "../../assets/images/university-of-southampton-malaysia.webp";
import YTL from "../../assets/images/ytl.webp";
import Reading from "../../assets/images/university-of-reading-malaysia.webp";
import UOC from "../../assets/images/university-of-cyberjaya.webp";
import UOW from "../../assets/images/uow.webp";

export const featuredUniversities = [
  {
    id: 1,
    image: APU,
    name: "Asia Pacific University (APU)",
    description:
      "Award-winning university specializing in Technology, Innovation & Creativity",
    scholarship: "Up to 50% Scholarship",
    color: "from-orange-400 to-pink-500",
  },
  {
    id: 2,
    image: HeriotWatt,
    name: "Heriot-Watt University Malaysia",
    description: "UK degree with Malaysian fees — Engineering, Business & more",
    scholarship: "Up to 30% Scholarship",
    color: "from-purple-400 to-indigo-500",
  },
  {
    id: 3,
    image: Curtin,
    name: "Curtin University Malaysia",
    description:
      "Australian university offering globally recognized qualifications in engineering, business, and more.",
    scholarship: "Up to MYR 10,000",
    color: "from-amber-400 to-orange-500",
  },
  {
    id: 4,
    image: Segi,
    name: "SEGi University",
    description:
      "Leading university for healthcare, business, and engineering with affordable quality education.",
    scholarship: "Up to 35% Scholarship",
    color: "from-pink-400 to-rose-500",
  },
];

export const benefits = [
  {
    title: "Higher Scholarships",
    description:
      "Get access to exclusive scholarship deals not available elsewhere",
    emoji: "💰",
  },
  {
    title: "Extra Rebate",
    description:
      "Additional rebates for early applications through SCS Education",
    emoji: "🎁",
  },
  // {
  //   title: "Direct Application",
  //   description:
  //     "Fast-track your application with our direct university connections",
  //   emoji: "⚡",
  // },
  {
    title: "Experienced counsellors",
    description:
      "Our team has 10+ years of experience in education consultancy",
    emoji: "🎓",
  },
  {
    title: "Campus Visit Arrangement",
    description: "We arrange campus tours so you can explore before deciding",
    emoji: "🏫",
  },
  {
    title: "Trusted by students across Malaysia",
    description:
      "Thousands of students have successfully enrolled through our guidance",
    emoji: "⭐",
  },
  {
    title: "Fast & personalized guidance",
    description: "Get tailored advice based on your SPM/UEC results and goals",
    emoji: "🚀",
  },
];

export const testimonials = [
  {
    name: "Garyee Tai",
    quote:
      "Because I don't know which university to go to, and I don't know what courses to study. I met Genusis Liew, the counselor and in the end her patiently helped me find the courses which suit me and near my house which is APU and even got a scholarship",
    uni: "APU Student",
    color: "bg-gradient-to-br from-orange-100 to-pink-100",
  },
  {
    name: "Jiaxuan",
    quote:
      "A big thanks to SCS Education, especially Eunice. She was incredibly patient, supportive,professional and responded quickly throughout my university application journey. Thanks to her guidance, I was successfully accepted into APU University and received a scholarship. If you are unsure about which course to choose or which university to enroll in, don’t worry. They offer a personality assessment and will recommend the most suitable university based on your interests, budget. Thanks again to Eunice and SCS Education!",
    uni: "APU Student",
    color: "bg-gradient-to-br from-purple-100 to-indigo-100",
  },
  {
    name: "Anonymous",
    quote:
      "Thank you so much for the great service. I'm glad that SCS helping me to get 50% scholarships for my diploma study and free hostels for 4 months in UOW Malaysia.",
    uni: "UOW Malaysia Student",
    color: "bg-gradient-to-br from-amber-100 to-orange-100",
  },
];

export const faqs = [
  {
    question: "How do I apply through SCS Education?",
    answer:
      "Simply fill out the form and our counsellor will contact you within 24 hours to guide you through the entire process.",
  },
  {
    question: "Are there any service charges?",
    answer:
      "No! Our counselling and application services are completely FREE for students.",
  },
  {
    question: "How fast is the application process?",
    answer:
      "With our direct connections, applications are typically processed within 24 hours.",
  },
  {
    question: "What documents do I need?",
    answer:
      "You'll need your SPM/UEC results, IC/passport copy, and passport-sized photos. We'll guide you on specific requirements.",
  },
  {
    question: "Can I still get scholarships with my SPM/UEC trial results?",
    answer:
      "Yes! We work with universities offering scholarships for various result ranges. Contact us to explore your options.",
  },
];

export const moreUniversities = [
  {
    name: "APU",
    image: APU,
    fullName: "Asia Pacific University (APU)",
    location: "Bukit Jalil, Kuala Lumpur",
    ranking: "Top 50 QS SEA",
    scholarships: "7 Scholarships",
    employment: "100% Graduate Employment Rate",
    description:
      "With students from more than 130 countries, APU is known as a leading technology and award-winning university for its high quality graduates and achievements at local and international levels.",
    courses: [
      { name: "Computing and IT", fee: "MYR 26,400" },
      { name: "Engineering", fee: "MYR 26,400" },
      { name: "Business", fee: "MYR 26,400" },
      { name: "Accounting and Finance", fee: "MYR 26,400" },
    ],
    color: "from-rose-400 to-pink-500",
  },
  {
    name: "Curtin",
    image: Curtin,
    fullName: "Curtin University Malaysia",
    location: "Miri, Sarawak",
    ranking: "Top 200 QS World",
    scholarships: "7 Scholarships",
    employment: "96% Graduate Employment Rate",
    description:
      "Australian university offering globally recognized qualifications in engineering, business, and more.",
    courses: [
      { name: "Engineering", fee: "MYR 27,200" },
      { name: "Business", fee: "MYR 27,300" },
      { name: "Computing", fee: "MYR 34,500" },
      { name: "Science", fee: "MYR 27,300" },
    ],
    color: "from-yellow-400 to-orange-500",
  },
  {
    name: "Heriot-Watt",
    image: HeriotWatt,
    fullName: "Heriot-Watt University Malaysia",
    location: "Putrajaya",
    ranking: "Top 300 QS World",
    scholarships: "6 Scholarships",
    employment: "97% Graduate Employment Rate",
    description:
      "UK degree with Malaysian fees — Engineering, Business & more with British education standards.",
    courses: [
      { name: "Engineering", fee: "MYR 49,620" },
      { name: "Business", fee: "MYR 25,710" },
      { name: "Built Environment", fee: "MYR 39,000" },
      { name: "Psychology", fee: "MYR 35,400" },
    ],
    color: "from-purple-400 to-indigo-500",
  },
  {
    name: "SEGi",
    image: Segi,
    fullName: "SEGi University",
    location: "Kota Damansara, Selangor",
    ranking: "Top Healthcare University",
    scholarships: "10 Scholarships",
    employment: "92% Graduate Employment Rate",
    description:
      "Leading university for healthcare, business, and engineering with affordable quality education.",
    courses: [
      { name: "Nursing", fee: "MYR 27,000" },
      { name: "Business", fee: "MYR 37,700" },
      { name: "Engineering", fee: "MYR 37,700" },
      { name: "Pharmacy", fee: "MYR 103,360" },
    ],
    color: "from-sky-400 to-blue-500",
  },
  {
    name: "Help",
    image: Help,
    fullName: "Help University",
    location: "Subang Bestari, Shah Alam",
    ranking: "Top 620 QS Asia",
    scholarships: "10+ Scholarships",
    employment: "99.9% Graduate Employment Rate",
    description:
      "Help University in Malaysia is a private institution known for practical, industry-oriented programs and a strong focus on business, psychology, and education.",
    courses: [
      { name: "Psychology", fee: "MYR 97,500" },
      { name: "Law", fee: "MYR 77,190" },
      { name: "Education", fee: "MYR 16,400" },
    ],
    color: "from-blue-400 to-cyan-500",
  },
  {
    name: "IGlobal",
    image: IGlobal,
    fullName: "IGlobal Academy",
    location: "Shah Alam, Selangor",
    ranking: "Globally-Inspired Excellence",
    scholarships: "10+ Scholarships",
    employment: "90% Graduate Employment Rate",
    description:
      "IGLOBAL Academy Malaysia is a private, HRDF-registered training and business-school institution offering internationally recognized diploma, bachelor’s and master’s programs with a global outlook.",
    courses: [
      { name: "Business & Management", fee: "MYR 13,800" },
      { name: "Accounting & Finance", fee: "MYR 13,800" },
      { name: "Digital Marketing & Creative Business", fee: "MYR 10,800" },
    ],
    color: "from-green-400 to-emerald-500",
  },
  {
    name: "MUCM",
    image: Manipal,
    fullName: "Manipal University College Malaysia",
    location: "Bukit Baru, Melaka",
    ranking: "#43 in Malaysia",
    scholarships: "10+ Scholarships",
    employment: "92% Graduate Employment Rate",
    description:
      "Manipal University College Malaysia is a private institution offering internationally recognized programs in engineering, business, and health sciences with a focus on global education standards.",
    courses: [
      { name: "Medicine / Dentistry & Allied‑Health", fee: "MYR 360,000" },
      { name: "Health & Medical Sciences (Non‑Doctoral)", fee: "MYR 49,725" },
      { name: "Pre‑University / Foundation", fee: "MYR 16,000" },
    ],
    color: "from-red-400 to-pink-500",
  },
  {
    name: "MIA",
    image: MIA,
    fullName: "Malaysian Institute of Art",
    location: "Taman Melawati, Kuala Lumpur",
    ranking: "#104 in Malaysia",
    scholarships: "10+ Scholarships",
    employment: "90% Graduate Employment Rate",
    description:
      "The Malaysian Institute of Art (MIA) is a leading private institution specializing in creative arts, design, and visual communications education in Malaysia.",
    courses: [
      { name: "Interior / Interior Architecture & Design", fee: "MYR 37,290" },
      { name: "Graphic / Digital / Fine Arts & Design", fee: "MYR 36,300" },
      { name: "Foundation / Certificate Art & Design", fee: "MYR 9,000" },
    ],
    color: "from-indigo-400 to-purple-500",
  },
  {
    name: "QIU",
    image: QIU,
    fullName: "Quest International University",
    location: "Ipoh, Perak",
    ranking: "#68 in Malaysia",
    scholarships: "10+ Scholarships",
    employment: "90% Graduate Employment Rate",
    description:
      "Quest International University (QIU) is a private, research‑led university in Ipoh, Malaysia offering a wide range of industry‑relevant programmes aimed at producing well‑rounded graduates equipped for both professional careers and social responsibility.",
    courses: [
      { name: "Business / Management / Commerce", fee: "MYR 12,800" },
      { name: "Computing / IT / Computer Science", fee: "MYR 15,300" },
      {
        name: "Engineering / Technology / Mechatronics / Electronics",
        fee: "MYR 28,400",
      },
      { name: "Medicine / Health Sciences", fee: "MYR 138,400" },
    ],
    color: "from-amber-400 to-orange-500",
  },
  {
    name: "Raffles",
    image: Raffles,
    fullName: "Raffles University",
    location: "Johor Bahru, Johor",
    ranking: "#74 in Malaysia",
    scholarships: "10+ Scholarships",
    employment: "98% Graduate Employment Rate",
    description:
      "Raffles University is a private Malaysian university in Johor that emphasizes hands‑on, practice‑oriented education — combining teaching with real‑world projects to prepare students for careers in fields like design, business, AI/robotics and social sciences.",
    courses: [
      { name: "Business / Management / Commerce", fee: "MYR 24,150" },
      {
        name: "Information Technology / Data Science / AI / Computing",
        fee: "MYR 47,250",
      },
      {
        name: "Design / Creative / Multimedia / Interior Design",
        fee: "MYR 24,150",
      },
      { name: "Social Sciences / Psychology", fee: "MYR 84,400" },
    ],
    color: "from-pink-400 to-rose-500",
  },
  {
    name: "UOSM",
    image: Southampton,
    fullName: "University of Southampton Malaysia",
    location: "Iskandar Puteri, Johor",
    ranking: "#72 in Malaysia",
    scholarships: "10+ Scholarships",
    employment: "98% Graduate Employment Rate",
    description:
      "University of Southampton Malaysia (UoSM) is a Malaysian branch campus of University of Southampton (UK), offering UK‑standard engineering, computing and business degrees in Iskandar Puteri, Johor.",
    courses: [
      { name: "Computer Science / IT", fee: "MYR 126,000" },
      {
        name: "Business / Management / Finance / Accounting",
        fee: "MYR 121,455",
      },
      {
        name: "Engineering",
        fee: "MYR 206,800",
      },
    ],
    color: "from-teal-400 to-cyan-500",
  },
  {
    name: "YTL",
    image: YTL,
    fullName: "YTL International College of Management",
    location: "Bukit Bintang, Kuala Lumpur",
    ranking: "#186 in Malaysia",
    scholarships: "10+ Scholarships",
    employment: "56% Graduate Employment Rate in YTL Hotels/ Resorts",
    description:
      "YTL International College of Hotel Management (YTL‑ICHM) is a Malaysian hospitality college that trains students in hotel, culinary, events and hospitality management — using “live‑hotel” campus facilities and industry internships to prepare them for careers in hotels and resorts.",
    courses: [
      { name: "Diploma in Hotel Management", fee: "MYR 42,000" },
      {
        name: "Diploma in Culinary Arts",
        fee: "MYR 42,000",
      },
      {
        name: "Diploma in Event Management",
        fee: "MYR 42,000",
      },
    ],
    color: "from-rose-400 to-pink-500",
  },
  {
    name: "UOR",
    image: Reading,
    fullName: "University of Reading Malaysia",
    location: "Iskandar Puteri, Johor",
    ranking: "#194 QS World Ranking 2026",
    scholarships: "10+ Scholarships",
    employment: "98% Graduate Employment Rate",
    description:
      "The University of Reading Malaysia (UORM) is the Malaysian branch campus of the UK’s University of Reading, offering British-quality degrees in business, law, finance, psychology, and built environment disciplines at EduCity Iskandar Puteri.",
    courses: [
      { name: "BSc Business and Management", fee: "MYR 40,800" },
      { name: "BSc Accounting and Finance", fee: "MYR 40,800" },
      { name: "BSc Psychology", fee: "MYR 37,600" },
      { name: "Bachelor of Laws", fee: "MYR 40,800" },
    ],
    color: "from-rose-400 to-pink-500",
  },
  {
    name: "UOC",
    image: UOC,
    fullName: "University of Cyberjaya Malaysia",
    location: "Cyberjaya",
    ranking: "#951-1000 QS World Ranking 2026",
    scholarships: "10+ Scholarships",
    employment: "94.5% Graduate Employment Rate",
    description:
      "University of Cyberjaya (UoC) is a Malaysian private university specializing in health sciences, medical, and allied health programs, offering industry-focused degrees with professional accreditation.",
    courses: [
      { name: "Bachelor of Pharmacy (Honours)", fee: "MYR 124,400" },
      {
        name: "Bachelor of Physiotherapy (Honours)",
        fee: "MYR 94,400",
      },
      {
        name: "Bachelor of Business Administration (Honours)",
        fee: "MYR 53,800",
      },
    ],
    color: "from-yellow-400 to-orange-500",
  },
  {
    name: "UOW",
    image: UOW,
    fullName: "University of Wollongong Malaysia",
    location: "Iskandar Puteri, Johor",
    ranking: "#184 QS World 2026",
    scholarships: "10+ Scholarships",
    employment: "95.7% Graduate Employment Rate",
    description:
      "The University of Wollongong Malaysia (UOWM) is the Malaysian campus of Australia’s University of Wollongong, offering internationally recognized Australian degrees in engineering, IT, business, and sciences at its EduCity Iskandar Puteri campus.",
    courses: [
      { name: "Business & Management", fee: "MYR 23,400" },
      {
        name: "Computing & IT",
        fee: "MYR 22,815",
      },
      {
        name: "Accounting & Finance",
        fee: "MYR 11,950",
      },
    ],
    color: "from-purple-400 to-indigo-500",
  },
];

export const footerData = {
  aboutTitle: "About SCS Education",
  aboutDesc:
    "SCS Education is Malaysia’s leading one-stop education service center, specializing in guidance for SPM, O-Level, STPM, UEC, and A-Level students — including course advice, university overviews, scholarship assistance, and career counseling.",
  partnerUniTitle: "Partner University",
  partnerUni: [
    "APU",
    "Curtin",
    "Heriot-Watt",
    "SEGi",
    "Help",
    "IGlobal",
    "MUCM",
    "MIA",
    "QIU",
    "Raffles",
    "UOSM",
    "YTL",
    "UOR",
    "UOC",
    "UOW",
  ],
  contactTitle: "Contact Info",
  contact: [
    "📞 Phone: 011-12870256",
    "✉️ Email: ng.scseducation@gmail.com",
    "📌 Office: Kuantan (HQ), Shah Alam, Sitiawan",
  ],
};
